export const SHIPPING_LABEL_WIDTH_INCHES = 4;
export const SHIPPING_LABEL_HEIGHT_INCHES = 6;
export const SHIPPING_LABEL_CUSTOM_SECTION_MIN_HEIGHT_INCHES = 0.25;
export const SHIPPING_LABEL_CUSTOM_SECTION_MAX_HEIGHT_INCHES = 1;
export const SHIPPING_LABEL_CUSTOM_SECTION_DEFAULT_HEIGHT_INCHES = 0.25;

export function getShippingLabelCarrierAreaHeightInches(
  customSectionHeightInches: number,
): number {
  return SHIPPING_LABEL_HEIGHT_INCHES - customSectionHeightInches;
}
